import type { SessionFull } from '../api/missions';
import type { CardServerState, TestTask } from '../api/tests';

/** What the card's page shows of its server: nothing made yet, or the four states the platform names. */
export type CardServerPhase = 'none' | CardServerState;

/**
 * Where the card's server is. The platform says it on the card itself
 * (`task.server`); a card read from a platform that does not yet falls back
 * to what the session's own page knows, where a started session is "starting"
 * until an event of the runtime's has arrived.
 */
export function cardServerPhase(task: TestTask, session: SessionFull | null): CardServerPhase {
  if (task.server) return task.server.state;
  if (!task.sessionCode || !session) return 'none';
  if (session.session.state === 'SCHEDULED') return 'waiting';
  if (session.session.state === 'ENDED') return 'ended';
  return session.lastEventSeq >= 0 ? 'ready' : 'starting';
}

/** After this many minutes the page says the start is slow: the starts timed took one to three (sessions 74xpg and 2bv9b, 2026-09-29). */
export const SLOW_START_MINUTES = 12;
